import { useTLang } from 'intl/intl';

export function useMenuTabsLang() {
  return {
    novelties: {
      title: useTLang({ id: 'notification.mozart.031' }),
      description: useTLang({ id: 'notification.mozart.005' }),
    },
    complaints: {
      title: useTLang({ id: 'notification.mozart.033' }),
      description: useTLang({ id: 'notification.mozart.008' }),
    },
  };
}
